import React, { useEffect, useState } from "react";
import "./style.css";
import DeleteIcon from "../../src/Assets/DeleteIcon";
import { getAPIUrlBM } from "../../../utils/config";
import Delete from "../../../Apis/backlink/Delete";
import { useNavigate } from "react-router-dom";
import Post from "../../../Apis/backlink/Post";
// import ShowLogs from "./ShowLogs";
import StyledTooltip from "../StyledTooltip";
import ShowLogs from "./ShowLogs";
import RecycleIcon from "../../src/Assets/RecycleIcon";
import EditIcon from "../../src/Assets/EditIcon";
import CrossIcon from "../../src/Assets/CrossIcon";
import WarningIcon from "../../src/Assets/WarningIcon";
import ErrorIcon from "../../src/Assets/ErrorIcon";
import LinkOutlinedIcon from "../../src/Assets/LinkOutlinedIcon";
import KeyboardArrowDownIcon from "../../src/Assets/KeyboardArrowDownIcon";
import KeyboardArrowUpIcon from "../../src/Assets/KeyboardArrowUpIcon";

function LinkTable({
  data,
  deleteLinkItem,
  showDelete,
  expandAll,
  setDeleteAll,
  deleteAll,
}) {
  const sweet = window.sweet;
  const [showLogs, setShowLogs] = useState(expandAll ?? false);
  const navigate = useNavigate();
  useEffect(() => {
    setShowLogs(expandAll);
  }, [expandAll]);

  const {
    linkCreateDate,
    anchor: anchorText,
    link_from: linkFROM,
    link_id,
    link_to: linkTO,
    list_id,
    list_name,
    rel_tag,
    // connectedLogs,
    linkNotes: notesText,
  } = data;
  const [anchor, setAnchor] = useState(anchorText);
  const [link_from, setLinkFrom] = useState(linkFROM);
  const [link_to, setLinkTo] = useState(linkTO);
  const [notes, setNotes] = useState(notesText);
  console.log(data, "NOTES ARE COMING");
  const deleteLink = async () => {
    window
      .sweet({
        title: "Are you sure?",
        text: "Once deleted, you will not be able to recover this link!",
        icon: "warning",
        buttons: true,
      })
      .then(async (willDelete) => {
        if (willDelete) {
          deleteLinkItem(list_id, link_id);
          const url = getAPIUrlBM();
          // eslint-disable-next-line no-unused-vars
          const res = await Delete(url + "/deleteLink", {
            listId: list_id,
            linkId: link_id,
          });
          sweet({
            title: "Alert!",
            text: `#${link_id} is deleted Successfully.`,
            icon: "success",
          });
        } else {
          sweet({
            title: "Alert!",
            text: `#${link_id} is not deleted.`,
            icon: "success",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const [edit, setEdit] = useState(false);

  const editLink = async () => {
    try {
      const url = getAPIUrlBM();
      const linkFromValue = document.getElementById(`editLinkFrom`).value;
      let linkToValue = document.getElementById(`editLinkTo`).value;
      const relTagValue = document.getElementById(`editRelTag`).value;
      const anchorValue = document.getElementById(`editAnchor`).value;
      const notes = document.getElementById(`editNotes`).value;
      linkToValue = linkToValue.replace("https://", "");
      linkToValue = linkToValue.replace("http://", "");
      linkToValue = `https://${linkToValue}`;
      const res = await Post(url + "/editLink", {
        listId: list_id,
        linkId: link_id,
        linkFrom: linkFromValue,
        linkTo: linkToValue,
        relTag: relTagValue,
        anchorText: anchorValue,
        notes: notes,
      });
      if (res.message === "Link Edited Sucessfully") {
        setLinkFrom(linkFromValue);
        setLinkTo(linkToValue);
        setAnchor(anchorValue);
        setNotes(notes);
        window.sweet({
          text: "Link Edited Sucessfully",
          icon: "success",
        });
        setEdit(false);
      } else {
        window.sweet({
          text: res.message,
          icon: "error",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  const AddLink = async () => {
    try {
      const url = getAPIUrlBM();

      const res = await Post(url + "/crawl/link", {
        linkId: link_id,
      });
      if (res.message === "Crawling Link Successfully") {
        window.sweet({
          text: "Link Crawled Successfully",
          icon: "success",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      {/* <tr
        className="listTableRow"
        id={`list${list_id}Link${list_id}`}
        key={link_id}
      >
        <td className="listID largeCell">#{link_id}</td>
        <td className="mediumCell">
          {new Date(create_date).toLocaleDateString()}
        </td>
        <td className="tooltip-wrap">
          <img
            src={
              data.index_status === "indexed"
                ? "/link.png"
                : data.index_status === "not indexed"
                ? "/close.png"
                : "/warning.png"
            }
            alt="index status of the link"
            width={20}
            height={20}
          />
          <div
            className="tooltip-content"
            style={{
              position: "absolute",
              // width: "100%",
              width: "max-content",
            }}
          >
            {data.index_status ?? "Not Checked"}
          </div>
        </td>
        <td className="largeCell">
          <div className="oneLineRow ">
            <a
              href={`https://` + link_from}
              target="_blank"
              className="blueLink"
            >
              {link_from}
            </a>
          </div>
        </td>
        <td className="smallCell">
          <div className="oneLineRow ">
            <a href={`https://` + link_to} target="_blank" className="blueLink">
              {link_to}
            </a>
          </div>
        </td>
        <td
          className="blue-text hyperLink largeCell"
          onClick={() => navigate("/backlink/list/" + `${list_name}`)}
        >
          {list_name}
        </td>
        <td className="smallCell ">{rel_tag ?? "----"}</td>
        <td className="mediumCell tooltip-wrap">
          <div className="oneLineRow ">{anchor ?? "----"}</div>
          <div
            className="tooltip-content"
            style={{
              position: "absolute",
              width: "100%",
              // width: "max-content",
            }}
          >
            {anchor ?? "----"}
          </div>
        </td>
        <td className="mediumCell tooltip-wrap">
          <div className="oneLineRow ">{notes === "NULL" ? "----" : notes}</div>
          <div
            className="tooltip-content"
            style={{
              position: "absolute",
              width: "100%",
              // width: "max-content",
            }}
          >
            {notes === "NULL" ? "----" : notes}
          </div>
        </td>
        <td className="mediumCell">
          {data?.error?.length ? data?.error : "-----"}
        </td>
        <td className="largeCell">
          <div className="col-center">
            <div className="row-center">
              <p
                className={
                  data?.status == "Present"
                    ? "successStatus  hollowStatus status"
                    : data?.status == "Ok"
                    ? "okStatus  hollowStatus status"
                    : data?.status == "Absent"
                    ? "absentStatus  hollowStatus status"
                    : data?.status == "Error"
                    ? "errorStatus hollowStatus  status"
                    : "notCheckedStatus hollowStatus  status"
                }
              >
                {data?.status?.length ? data?.status?.substr(0, 2) : "NA"}
              </p>
              {showDelete && (
                <div className="Hoverimportant position-relative">
                  <div onClick={deleteLink} style={{ cursor: "pointer" }}>
                    <DeleteIcon />
                  </div>
                  <div
                    style={{
                      left: "-100%",
                    }}
                    className=" position-absolute topimportant"
                  >
                    Delete Link
                  </div>
                </div>
              )}
              {showDelete && (
                <div className="Hoverimportant position-relative">
                  <div
                    onClick={() => {
                      setEdit((e) => !e);
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src="../../../editIcon.png"
                      width={20}
                      alt=""
                      height={20}
                    />
                  </div>
                  <div
                    style={{
                      left: "-100%",
                    }}
                    className=" position-absolute topimportant"
                  >
                    Edit Link
                  </div>
                </div>
              )}
              <div className="Hoverimportant position-relative">
                <div
                  onClick={() => {
                    AddLink();
                  }}
                  style={{ cursor: "pointer" }}
                >
                  <img
                    src="../../../recycle.png"
                    width={20}
                    alt=""
                    height={20}
                  />
                </div>
                <div
                  style={{
                    left: "-5rem",
                  }}
                  className=" position-absolute topimportant"
                >
                  Recrawl Link
                </div>
              </div>
            </div>

            {(data?.error || data?.status) && (
              <button
                className="logButton"
                onClick={() => setShowLogs(!showLogs)}
              >
                {!showLogs ? `View Older Logs ` : "Hide  Older Logs "}
                {showLogs ? (
                  <KeyboardArrowUpIcon sx={{ color: "#5541D7" }} />
                ) : (
                  <KeyboardArrowDownIcon sx={{ color: "#5541D7" }} />
                )}
              </button>
            )}
          </div>
        </td>
      </tr> */}
      {/* {showLogs && <ShowLogs key={link_id} linkId={link_id} />} */}
      <div className="gridContainerInTable">
        <div className="gridItemInTable text-left">
          <input
            type="checkbox"
            checked={deleteAll?.includes(link_id)}
            onChange={(e) => {
              if (e.target.checked) {
                setDeleteAll((d) => [...d, link_id]);
              } else {
                setDeleteAll((d) => d.filter((id) => id !== link_id));
              }
            }}
          />
        </div>
        <div
          className="gridItemInTable "
          style={{
            color: "grey",
            fontSize: "0.75em",
          }}
        >
          <span className="oneLineRow">#{link_id}</span>
        </div>
        <div
          className="gridItemInTable"
          style={{
            color: "grey",
            // textAlign: "unset",
          }}
        >
          {new Date(linkCreateDate).toLocaleDateString()}
        </div>
        <StyledTooltip title={data.index_status ?? "Not Checked"}>
          <div
            className="gridItemInTable"
            style={{
              overflow: "unset",
            }}
          >
            {/* <img
              src={
                data.index_status === "indexed"
                  ? "/link.png"
                  : data.index_status === "not indexed"
                  ? "/close.png"
                  : data.index_status === "May be indexed"
                  ? "/caution.png"
                  : "/warning.png"
              }
              alt="index status of the link"
              width={20}
              height={20}
            /> */}

            {data.index_status === "indexed" ? (
              // <LinkOutlinedIcon color="green" />
              // <img src="./indexed2.png" alt=""/>
              <img src="/indexed2.svg" alt="" width={25} height={25} />
            ) : data.index_status === "not indexed" ? (
              // <CrossIcon color="red" />
              <img src="/notindexed.png" alt="" width={25} height={25} />
            ) : data.index_status === "May be indexed" ? (
              <img
                src="/warningInLinktable.png"
                alt=""
                width={25}
                height={25}
              />
            ) : (
              "---"
              // <ErrorIcon color="gray" />
              // <img src="/notindexed.png" alt="" width={25} height={25} />
            )}
            {/* <div
              className="tooltip-content"
              style={{
                position: "absolute",
                // width: "100%",
                width: "max-content",
              }}
            >
              {data.index_status ?? "Not Checked"}
            </div> */}
          </div>
        </StyledTooltip>
        <div className="gridItemInTable">
          <StyledTooltip title={`https://` + link_from}>
            <div className="oneLineRow ">
              {/*  eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                href={`https://` + link_from}
                target="_blank"
                className="blueLink"
              >
                {link_from}
              </a>
            </div>
          </StyledTooltip>
        </div>
        <div className="gridItemInTable">
          <StyledTooltip title={`https://` + link_to}>
            <div className="oneLineRow ">
              <a
                href={`https://` + link_to}
                target="_blank"
                className="blueLink"
              >
                {link_to}
              </a>
            </div>
          </StyledTooltip>
        </div>
        <div
          className="gridItemInTable blueLink oneLineRow hyperLink"
          onClick={() => navigate("/backlink/list/" + `${list_name}`)}
        >
          {list_name}
        </div>
        <div className="gridItemInTable">
          <div className="oneLineRow ">{rel_tag ?? "----"}</div>
        </div>
        <div
          className="gridItemInTable"
          style={{
            overflow: "unset",
          }}
        >
          <StyledTooltip title={anchor ?? "----"}>
            <div className="oneLineRow ">
              {!anchor
                ? "----"
                : anchor.length > 10
                ? anchor.substr(0, 10) + "..."
                : anchor}
            </div>
          </StyledTooltip>
          {/* <div
            className="toolTipApply tooltip-content"
            style={{
              position: "absolute",
              width: "max-content",
              maxWidth: "max-content",
              left: 0,
              zIndex: 5,
            }}
          >
            {!anchor ? "----" : anchor}
          </div> */}
        </div>
        <div
          className="gridItemInTable"
          style={{
            overflow: "unset",
          }}
        >
          <StyledTooltip title={notes ?? "----"}>
            <div className="oneLineRow ">
              {!notes
                ? "----"
                : notes.length > 10
                ? notes.substr(0, 10) + "..."
                : notes}
            </div>
          </StyledTooltip>
          {/* <div
            className="toolTipApply tooltip-content"
            style={{
              position: "absolute",
              width: "max-content",
              maxWidth: "max-content",
              left: 0,
              zIndex: 5,
            }}
          >
            {!notes ? "----" : notes}
          </div> */}
        </div>
        <div className="gridItemInTable">
          <StyledTooltip title={data?.error ?? "----"}>
            <div className="oneLineRow ">{data?.error ?? "----"}</div>
          </StyledTooltip>
        </div>
        <div className="gridItemInTable">
          <StyledTooltip title={data?.DA ?? "----"}>
            <div className="oneLineRow ">{data?.DA ?? "----"}</div>
          </StyledTooltip>
        </div>
        <div className="gridItemInTable">
          <StyledTooltip title={data?.spam_score ?? "----"}>
            <div className="oneLineRow ">{data?.spam_score ?? "----"}</div>
          </StyledTooltip>
        </div>
        <div className="gridItemInTable">
          <div className="col-center">
            <div className="row-center">
              <p
                className={
                  data?.status == "Present"
                    ? "successStatus  hollowStatus status"
                    : data?.status == "Ok"
                    ? "okStatus  hollowStatus status"
                    : data?.status == "Absent"
                    ? "absentStatus  hollowStatus status"
                    : data?.status == "Error"
                    ? "errorStatus hollowStatus  status"
                    : "notCheckedStatus hollowStatus  status"
                }
              >
                {data?.status?.length ? data?.status?.substr(0, 2) : "NA"}
              </p>
              {showDelete && (
                <StyledTooltip title="Delete Link">
                  <div
                    className="Hoverimportant position-relative"
                    style={{
                      zIndex: 1,
                    }}
                  >
                    <div onClick={deleteLink} style={{ cursor: "pointer" }}>
                      <DeleteIcon />
                    </div>
                    <div
                      style={{
                        left: "-100%",
                      }}
                      className=" position-absolute topimportant"
                    >
                      Delete Link
                    </div>
                  </div>
                </StyledTooltip>
              )}
              {showDelete && (
                <StyledTooltip title="Edit Link">
                  <div className="Hoverimportant position-relative">
                    <div
                      onClick={() => {
                        setEdit((e) => !e);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <EditIcon />
                    </div>
                    <div
                      style={{
                        left: "-100%",
                      }}
                      className=" position-absolute topimportant"
                    >
                      Edit Link
                    </div>
                  </div>
                </StyledTooltip>
              )}
              <StyledTooltip title="Recrawl Link">
                <div className="Hoverimportant position-relative">
                  <div
                    onClick={() => {
                      AddLink();
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    {/* <img
                            src="../../../recycle.png"
                            width={20}
                            alt=""
                            height={20}
                          /> */}
                    <RecycleIcon />
                  </div>
                  <div
                    style={{
                      left: "-5rem",
                    }}
                    className=" position-absolute topimportant"
                  >
                    Recrawl Link
                  </div>
                </div>
              </StyledTooltip>
            </div>

            {/* {(data?.error || data?.status) && ( */}
            <button
              className="logButton"
              onClick={() => setShowLogs(!showLogs)}
            >
              {!showLogs ? `View Older Logs ` : "Hide  Older Logs "}
              {showLogs ? (
                <KeyboardArrowUpIcon color="#5541D7" />
              ) : (
                <KeyboardArrowDownIcon color="#5541D7" />
              )}
            </button>
            {/* )} */}
          </div>
        </div>
      </div>
      {showLogs && <ShowLogs linkId={link_id} />}
      {edit && (
        <tr className="linkEditSection">
          <td className="" colSpan={2}>
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">
                Link From Page
              </label>
              <input
                id="editLinkFrom"
                placeholder="Link From Page"
                defaultValue={link_from}
              />
            </div>
          </td>
          <td className="">
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">
                Link To URL
              </label>
              <input
                id="editLinkTo"
                placeholder="Link To Url"
                defaultValue={link_to}
              />
            </div>
          </td>

          <td colSpan={2} className="">
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">Rel Tag</label>
              <select id="editRelTag" className="px-3">
                <option
                  defaultChecked={rel_tag === "dofollow"}
                  value="dofollow"
                >
                  dofollow
                </option>
                <option
                  defaultChecked={rel_tag === "no0follow"}
                  value="nofollow"
                >
                  nofollow
                </option>
              </select>
            </div>
          </td>
          {/* <td className="mediumCell tooltip-wrap"></td> */}
          <td className="" colSpan={2}>
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">Anchor</label>
              <input
                id="editAnchor"
                placeholder="Anchor Text"
                defaultValue={anchor}
              />
            </div>
          </td>
          <td className="smallCell" colSpan={1}>
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">Notes</label>
              <input id="editNotes" placeholder="Notes" defaultValue={notes} />
            </div>
          </td>
          {/* <td className="mediumCell"></td> */}
          <td className="" colSpan={2}>
            <div className="d-flex flex-column">
              <label className="gridItemInTableHeader pb-0 mb-0">
                {"\u00A0"}
              </label>

              <div className="">
                <button
                  className="px-3 py-2 mr-2 btnSuccess"
                  onClick={editLink}
                >
                  Save
                </button>
                <button
                  className="px-3 py-2 btnDanger"
                  onClick={() => {
                    setEdit((e) => !e);
                    window.sweet({
                      text: "Changes Discarded",
                      icon: "success",
                    });
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}

export default LinkTable;
